<template>
    <div>
        <page-title title="FAQS" />
        <v-container>
            <v-row class="faqs">
                <v-col cols="12" md="6">
                    <v-expansion-panels
                        v-for="(item, index) in firstCategoryDetail"
                        :key="index"
                        class="mb-6"
                        accordion
                    >
                        <v-expansion-panel>
                            <v-expansion-panel-header
                                class="faq-category text-md-subtitle-1 text-sm-subtitle-1 text-headeline"
                            >
                                <template #actions>
                                    <div class="center">
                                        <v-icon class="faqs-minus">
                                            mdi-minus
                                        </v-icon>
                                        <v-icon class="faqs-plus">
                                            mdi-plus
                                        </v-icon>
                                    </div>
                                </template>
                                {{ item.CategoryName }}
                            </v-expansion-panel-header>
                            <v-expansion-panel-content
                                class="pa-0"
                                color="#121212"
                            >
                                <v-expansion-panels hover flat>
                                    <v-expansion-panel
                                        v-for="(faq, index) in item.faqArray"
                                        :key="index"
                                        class="transparent"
                                    >
                                        <v-expansion-panel-header
                                            class="pa-0 text-sm-subtitle-1 text-md-subtitle-1 text-subtitle-2"
                                        >
                                            <template #actions>
                                                <v-icon color="white"
                                                    >mdi-chevron-down</v-icon
                                                >
                                            </template>
                                            <div class="lh-1_5">
                                                <!-- <span>{{ faq.number }}</span> -->
                                                {{ faq.question }}
                                            </div>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content
                                            class="body-2 text-justify py-2 px-7 text-outlined"
                                        >
                                            <span v-html="faq.answer">{{
                                                faq.answer | makeSymbol
                                            }}</span>

                                            <!-- <div class="mt-2" v-if="faq.bullets">
                          <ul
                            v-for="item in faq.bullets"
                            :key="item.bullet"
                            class="mt-1"
                          >
                            <li v-if="item.bullet">
                              <span v-html="item.bullet"></span>
                            </li>
                          </ul>
                        </div> -->
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
                <v-col cols="12" md="6">
                    <v-expansion-panels
                        v-for="(item, i) in secondCategoryDetail"
                        :key="i"
                        class="mb-6"
                        accordion
                    >
                        <v-expansion-panel>
                            <v-expansion-panel-header
                                class="faq-category text-md-subtitle-1 text-sm-subtitle-1 text-headeline"
                            >
                                <template #actions>
                                    <div class="center">
                                        <v-icon class="faqs-minus">
                                            mdi-minus
                                        </v-icon>
                                        <v-icon class="faqs-plus">
                                            mdi-plus
                                        </v-icon>
                                    </div>
                                </template>
                                {{ item.CategoryName }}
                            </v-expansion-panel-header>
                            <v-expansion-panel-content
                                class="pa-0"
                                color="#121212"
                            >
                                <v-expansion-panels hover flat>
                                    <v-expansion-panel
                                        v-for="(faq, index) in item.faqArray"
                                        :key="index"
                                        class="transparent"
                                    >
                                        <v-expansion-panel-header
                                            class="pa-0 text-sm-subtitle-1 text-md-subtitle-1 text-subtitle-2"
                                        >
                                            <template #actions>
                                                <v-icon color="white"
                                                    >mdi-chevron-down</v-icon
                                                >
                                            </template>
                                            <div class="lh-1_5">
                                                <!-- <span>{{ faq.number }}</span> -->
                                                {{ faq.question }}
                                            </div>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content
                                            class="body-2 text-justify py-2 px-7 text-outlined"
                                        >
                                            <span v-html="faq.answer">{{
                                                faq.answer | makeSymbol
                                            }}</span>

                                            <!-- <div class="mt-2" v-if="faq.bullets">
                          <ul
                            v-for="item in faq.bullets"
                            :key="item.bullet"
                            class="mt-1"
                          >
                            <li v-if="item.bullet">
                              <span v-html="item.bullet"></span>
                            </li>
                          </ul>
                        </div> -->
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
                <v-col cols="12">
                    <div v-if="CategoryDetail.length <= 0" class="text-center">
                        No data Found
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import PageTitle from "@/components/PageTitle"
export default {
    components: { PageTitle },
    data() {
        return {
            Gpanel: "expand",
            repanel: "expand",
            Bpanel: "expand",
            SBpanel: "expand",
            BNpanel: "expand",
            PSpanel: "expand"
        }
    },
    head() {
        return {
            title: `Faq Section - ${process.env.APP_TITLE}`,
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: `Have any questions in mind related to any game of policy? Checkout out the frequently asked question and clear your doubts.`
                },
                {
                    name: "keywords",
                    content: `Frequently Asked Questions, FAQ by ${process.env.APP_TITLE}`
                }
            ]
        }
    },
    computed: {
        CategoryDetail() {
            return this.$store.state.faqs.CategoryDetail
        },
        firstCategoryDetail() {
            return this.$store.state.faqs.CategoryDetail1
        },
        secondCategoryDetail() {
            return this.$store.state.faqs.CategoryDetail2
        }
    },
    mounted() {
        this.$store.dispatch("faqs/faqs")
    },
    methods: {
        open(i) {
            this.active = false
            this.activeIndex = ""
            this.active = true
            this.activeIndex = i
        }
    }
}
</script>

<style lang="scss" scoped>
.v-expansion-panel-content .v-expansion-panel-content__wrap {
    padding: 0 12px 12px !important;
}

.v-expansion-panel-header {
    font-size: 1rem;
}
// .v-expansion-panel-content{
//   opacity: 0.75 !important;
// }

.faq-table {
    .border-bottom {
        border-bottom: 1px solid var(--v-orangemid-base) !important;
    }
}
.faq-category {
    border-radius: 5px;
    border: 1px solid #2f2f2f;
    color: #fff;
}
.mdi-chevron-down {
    background: var(--v-orangemid-base);
    border-radius: 50%;
    font-size: 16px;
    margin-right: 19px;
}
.v-item--active .faq-category {
    color: var(--v-orangemid-base);
}
.text-outlined {
    border: 1px solid var(--v-maroonColor-base);
    border-radius: 5px;
}

.faqs-minus {
    display: none;
}

.v-expansion-panel-header--active .faqs-minus {
    display: block;
}

.v-expansion-panel-header--active .faqs-plus {
    display: none;
}
</style>
